import React, { Component } from "react";
import { mailChimpSignUp } from "apis";
import Button from "@material-ui/core/Button";
import * as styles from "../../pages/newStyles.styles";
import styled, { css } from "react-emotion";

const formStyle = css`
  max-width: 50%;
`;

const formContainer = css`
  resize: none;

  margin: auto;
  margin-top: 1.5em;
  max-width: 80em;

  outline: none;
  box-shadow: none;

  padding: 1rem 1.5rem;

  visibility: visible;
  overflow: hidden;

  border: 1px solid #89d2d3;
  color: #1f3747;
  background: none;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 1000ms ease;
  -moz-transition: all 1000ms ease;
  -ms-transition: all 1000ms ease;
  -o-transition: all 1000ms ease;
  -webkit-transition: all 1000ms ease;
`;

const contactInput = css`
  padding: 5px;
  width: 100%;
  border: 1px solid #89d2d3;
  border-radius: 5px;
  font-size: 1em;
  margin-bottom: 20px;
  ::placeholder {
    color: #89d2d3;
    opacity: 1;
  }
`;

const errorText = css`
  color: #f17f7f;
  margin-bottom: 20px;
`;
const H5 = styled("h5")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 1.5em;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  margin: 20px 0px;
`;

const buttonContainerContact = css`
  text-align: center;
  @media (min-width: 768px) {
    text-align: right;
  }
`;

const row = css`
  display: flex;
  flex-wrap: wrap;
`;
const col = css`
  position: relative;
  width: 100%;
`;
const col12 = css`
  flex: 0 0 100%;
  max-width: 100%;
`;

const colMd6L = css`
  padding-right: 0px;
  @media (min-width: 768px) {
    flex: 0 0 50%;
    max-width: 50%;
    padding-right: 15px;
  }
`;
const colMd6R = css`
  padding-left: 0px;
  @media (min-width: 768px) {
    flex: 0 0 50%;
    max-width: 50%;
    padding-left: 15px;
  }
`;

class MailChimpForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: "",
      lastName: "",
      email: "",
      subscribed: localStorage.getItem(`chimpSub`),
      buttonText: "JOIN",
      errorText: "",
    };

    this.handleFirstNameChange = this.handleFirstNameChange.bind(this);
    this.handleLastNameChange = this.handleLastNameChange.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.changeButtonText = this.changeButtonText.bind(this);
  }

  changeButtonText = (text) => {
    this.setState({
      buttonText: text,
    });
  };
  slider() {
    var obj = document.getElementById("form"); //
    obj.style.visibility =
      obj.style.visibility == "visible" ? "hidden" : "visible";
    obj.style.height = "0px";
    obj.style.border = "none";
  }

  handleFirstNameChange = (event) => {
    this.setState({
      firstName: event.target.value,
    });
  };
  handleLastNameChange = (event) => {
    this.setState({
      lastName: event.target.value,
    });
  };
  handleEmailChange = (event) => {
    this.setState({
      email: event.target.value,
    });
  };

  handleSubmit(event) {
    if (this.state.subscribed === "null") {
      // console.log("Setting up sub");
      mailChimpSignUp(
        this.state.email,
        this.state.firstName,
        this.state.lastName
      ).then((result) => {
        // console.log("FORM GOT RESULT");
        // console.log(result);
        if (result === "err") {
          // console.log(
          //   "There was an issue adding you to our newsletter subscription."
          // );
          this.setState({
            errorText:
              "There was an issue adding you to our newsletter subscription.",
          });
        } else {
          this.changeButtonText("Subscribed!");
          this.setState({
            subscribed: true,
          });
          setTimeout(() => {
            this.slider();
          }, 2000);
          localStorage.setItem(`chimpSub`, true);
        }
      });
    }
    event.preventDefault();
  }

  render() {
    const { firstName, lastName, email, buttonText, subscribed } = this.state;
    return (
      <div className={formContainer} id="form">
        <form onSubmit={this.handleSubmit} className={formStyle}>
          <H5>
            Join our newsletter to get an inside scoop of Mobile360 development!
          </H5>
          <div className={row}>
            <div className={col + " " + col12 + " " + colMd6L}>
              <input
                className={contactInput}
                type="text"
                name="name"
                onChange={this.handleFirstNameChange}
                onBlur={this.handleFirstNameChange}
                value={firstName}
                required
                placeholder="First Name"
              />
            </div>
            <div className={col + " " + col12 + " " + colMd6R}>
              <input
                className={contactInput}
                type="text"
                name="name"
                onChange={this.handleLastNameChange}
                onBlur={this.handleLastNameChange}
                value={lastName}
                required
                placeholder="Last Name"
              />
            </div>
          </div>

          <input
            className={contactInput}
            type="email"
            name="email"
            onChange={this.handleEmailChange}
            onBlur={this.handleEmailChange}
            value={email}
            required
            placeholder="Email"
          />
          <p className={errorText}>{this.state.errorText}</p>
          <div className={buttonContainerContact}>
            <Button
              color="secondary"
              variant="contained"
              type="submit"
              style={{ width: "125px", marginBottom: "20px" }}
            >
              {buttonText}
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

export default MailChimpForm;
